<div class="details-wrapper">
    @if (allMastersService.masterDetailsIsLoading()) {
        <ng-container>
            <app-pure-original-info-skeleton></app-pure-original-info-skeleton>
        </ng-container>
    } @else {
        <div class="vehicle-info-container">
            <div class="main-title-img">
                <div class="title">
                    <span class="content-item">
                        <span class="content-item-text">
                            {{ allMastersService!.masterItem()["vehicleProducer"] }}
                        </span>
                    </span>
                </div>

                <div class="vehicle-info-card">
                    <img [src]="imageService.image" alt="" [ngClass]="!imageService.image ? 'startLoad' : ''">
                </div>

                <div class="main-details-container">
                    <span class="content-item">
                        <span class="content-item-text-details">
                            {{ allMastersService.masterItem()["vehicleSeries"] | shorten: 17 }}
                        </span>
                    </span>
                    <span class="content-item">
                        <span class="content-item-text-details">
                            {{ allMastersService.masterItem()["vehicleModelYear"] }}
                        </span>
                    </span>
                </div>
            </div>

        </div>

        <div class="new-tuning-container">
            <button class="add-tuning-button"
                    (click)="downloadMasterItem(allMastersService.masterItem().id, allMastersService.masterItem().winOLSReference, 'MASTER')"
                    [disabled]="isDownloadInProgress(+allMastersService.masterItem().id)">
                <span class="button-text">Download</span>
                <i class="bi bi-arrow-down-short"></i>
            </button>
            <button class="add-tuning-button"
                    (click)="deleteMasterItem(allMastersService.masterItem().id, 'MASTER')">
                <span class="button-text">Delete Master</span>
                <i class="bi bi-x"></i>
            </button>
            @if (isSuperAdmin()) {
                <div>
                    <div class="add-tuning-container">
                        <button class="add-tuning-button"
                                #historyTooltip="matTooltip"
                                [matTooltip]="tooltipMessage()"
                                matTooltipPosition="above"
                                (click)="openHistoryModal(allMastersService.masterItem().id)"
                        >
                            <span style="margin-left: 2px; margin-right: 2px" class="button-text">History</span>
                            <i class="bi bi-clock-history"></i>
                        </button>
                    </div>
                </div>
            }
            <button class="add-tuning-button"
                    (click)="editMasterItem(allMastersService.masterItem(), allMastersService.masterItem().id)">
                <i class="bi bi-pencil"></i>
            </button>
        </div>


        <form [formGroup]="masterDetailsFormGroup" (keydown.enter)="submitForm()"
              (keydown.escape)="cancelForm()">
            <div class="column-wrapper">
                <div class="first-column">
                    <div class="info-card-details">
                        <div class="info-column">
                            <span class="matching-detail-item">
                             <span class="matching-item-name">WinOls Reference</span>
                                <span class="matching-item-text">
                                {{ allMastersService.masterItem()["winOLSReference"] || '-' }}
                                </span>
                            </span>

                            <span class="matching-detail-item">
                                <span class="matching-item-name">Ecu Producer</span>
                                @if (!editFlags["ecuProducer"]) {
                                    <span class="matching-item-text cursor"
                                          (click)="toggleEdit('ecuProducer', $event)">
                                {{ masterDetailsFormGroup.get('ecuProducer').value ? masterDetailObject()["ecuProducer"] : '-' }}
                                </span>
                                } @else {
                                    <input type="text" class="matching-item-text"
                                           formControlName="ecuProducer"
                                           (click)="stopPropagation($event)"/>
                                }
                            </span>

                            <span class="matching-detail-item">
                                 <span class="matching-item-name">Ecu Build</span>
                                @if (!editFlags["ecuBuild"]) {
                                    <span class="matching-item-text cursor"
                                          (click)="toggleEdit('ecuBuild', $event)">
                            {{ masterDetailsFormGroup.get('ecuBuild').value ? masterDetailObject()["ecuBuild"] : '-' }}
                                </span>
                                } @else {
                                    <input type="text" class="matching-item-text"
                                           formControlName="ecuBuild"
                                           (click)="stopPropagation($event)"/>
                                }
                             </span>

                            <span class="matching-detail-item">
                            <span class="matching-item-name">Ecu Software Version</span>
                                @if (!editFlags["ecuSoftwareVersion"]) {
                                    <span class="matching-item-text cursor"
                                          (click)="toggleEdit('ecuSoftwareVersion', $event)">
                            {{ masterDetailsFormGroup.get('ecuSoftwareVersion').value ? masterDetailObject()["ecuSoftwareVersion"] : '-' }}
                             </span>
                                } @else {
                                    <input type="text" class="matching-item-text"
                                           formControlName="ecuSoftwareVersion"
                                           (click)="stopPropagation($event)"/>
                                }
                            </span>

                            <span class="matching-detail-item">
                                  <span class="matching-item-name">Ecu Software Version Version</span>
                                @if (!editFlags["ecuSoftwareVersionVersion"]) {
                                    <span class="matching-item-text cursor"
                                          (click)="toggleEdit('ecuSoftwareVersionVersion', $event)">
                            {{ masterDetailsFormGroup.get('ecuSoftwareVersionVersion').value ? masterDetailObject()["ecuSoftwareVersionVersion"] : '-' }}
                        </span>
                                } @else {
                                    <input type="text" class="matching-item-text"
                                           formControlName="ecuSoftwareVersionVersion"
                                           (click)="stopPropagation($event)"/>
                                }
                                   </span>

                            <span class="matching-detail-item">
                                <span class="matching-item-name">Ecu Prod Nr</span>
                                @if (!editFlags["ecuProdNr"]) {
                                    <span class="matching-item-text cursor"
                                          (click)="toggleEdit('ecuProdNr', $event)">
                            {{ masterDetailsFormGroup.get('ecuProdNr').value ? masterDetailObject()["ecuProdNr"] : '-' }}
                                </span>
                                } @else {
                                    <input type="text" class="matching-item-text"
                                           formControlName="ecuProdNr"
                                           (click)="stopPropagation($event)"/>
                                }
                             </span>


                        </div>

                        <div class="info-column">


                            <span class="matching-detail-item">
                    <span class="matching-item-name">Reading Hardware</span>
                                @if (!editFlags["readingHardware"]) {
                                    <span class="matching-item-text cursor"
                                          (click)="toggleEdit('readingHardware', $event)">
                            {{ masterDetailsFormGroup.get('readingHardware').value ? masterDetailObject()["readingHardware"] : '-' }}
                        </span>
                                } @else {
                                    <input type="text" class="matching-item-text"
                                           formControlName="readingHardware"
                                           (click)="stopPropagation($event)"/>
                                }
                </span>


                            <span class="matching-detail-item">
                    <span class="matching-item-name">Vehicle Producer</span>
                                @if (!editFlags["vehicleProducer"]) {
                                    <span class="matching-item-text cursor"
                                          (click)="toggleEdit('vehicleProducer', $event)">
                            {{ masterDetailsFormGroup.get('vehicleProducer').value ? masterDetailObject()["vehicleProducer"] : '-' }}
                        </span>
                                } @else {
                                    <input type="text" class="matching-item-text"
                                           formControlName="vehicleProducer"
                                           (click)="stopPropagation($event)"/>
                                }
                </span>

                            <span class="matching-detail-item">
                    <span class="matching-item-name">Vehicle Series</span>
                                @if (!editFlags["vehicleSeries"]) {
                                    <span class="matching-item-text cursor"
                                          (click)="toggleEdit('vehicleSeries', $event)">
                            {{ masterDetailsFormGroup.get('vehicleSeries').value ? masterDetailObject()["vehicleSeries"] : '-' }}
                        </span>
                                } @else {
                                    <input type="text" class="matching-item-text"
                                           formControlName="vehicleSeries"
                                           (click)="stopPropagation($event)"/>
                                }
                </span>

                            <span class="matching-detail-item">
                    <span class="matching-item-name">Vehicle Model</span>
                                @if (!editFlags["vehicleModel"]) {
                                    <span class="matching-item-text cursor"
                                          (click)="toggleEdit('vehicleModel', $event)">
                            {{ masterDetailsFormGroup.get('vehicleModel').value ? masterDetailObject()["vehicleModel"] : '-' }}
                        </span>
                                } @else {
                                    <input type="text" class="matching-item-text"
                                           formControlName="vehicleModel"
                                           (click)="stopPropagation($event)"/>
                                }
                </span>


                            <span class="matching-detail-item">
                    <span class="matching-item-name">Vehicle Name</span>
                                @if (!editFlags["engineName"]) {
                                    <span class="matching-item-text cursor"
                                          (click)="toggleEdit('vehicleName', $event)">
                            {{ masterDetailsFormGroup.get('engineName').value ? masterDetailObject()["engineName"] : '-' }}
                        </span>
                                } @else {
                                    <input type="text" class="matching-item-text"
                                           formControlName="ecuStgNr"
                                           (click)="stopPropagation($event)"/>
                                }
                </span>

                            <span class="matching-detail-item">
                    <span class="matching-item-name">Ecu Stg Nr</span>
                                @if (!editFlags["ecuStgNr"]) {
                                    <span class="matching-item-text cursor"
                                          (click)="toggleEdit('ecuStgNr', $event)">
                            {{ masterDetailsFormGroup.get('ecuStgNr').value ? masterDetailObject()["ecuStgNr"] : '-' }}
                        </span>
                                } @else {
                                    <input type="text" class="matching-item-text"
                                           formControlName="ecuStgNr"
                                           (click)="stopPropagation($event)"/>
                                }
                </span>
                        </div>
                    </div>
                </div>

            </div>


            <div *ngIf="showMore" class="info-card-details">
                <div class="info-column">
                <span class="matching-detail-item">
                         <span class="matching-item-name">Type</span>
                    @if (!editFlags["engineType"]) {
                        <span class="matching-item-text cursor"
                              (click)="toggleEdit('engineType', $event)">
                            {{ masterDetailsFormGroup.get('engineType').value ? masterDetailObject()["engineType"] : '-' }}
                        </span>
                    } @else {
                        <input type="text" class="matching-item-text"
                               formControlName="engineType"
                               (click)="stopPropagation($event)"/>
                    }
                     </span>


                    <span class="matching-detail-item">
                                <span class="matching-item-name">Date Uploaded</span>
                                <span class="matching-item-text">
                             {{ allMastersService.masterItem()["dateUploaded"] || '-' }}
                             </span>
                            </span>



                    <span class="matching-detail-item">
                    <span class="matching-item-name">Date Exported</span>
                    <span class="matching-item-text">
                        {{ allMastersService.masterItem()[""] || '-' }}
                    </span>
                </span>
                    <span class="matching-detail-item">
                    <span class="matching-item-name">Date Updated</span>
                    <span class="matching-item-text">
                        {{ allMastersService.masterItem()[""] || '-' }}
                    </span>
                </span>
                    <span class="matching-detail-item">
                    <span class="matching-item-name">Transmission</span>
                        @if (!editFlags["engineTransmission"]) {
                            <span class="matching-item-text cursor"
                                  (click)="toggleEdit('engineTransmission', $event)">
                            {{ masterDetailsFormGroup.get('engineTransmission').value ? masterDetailObject()["engineTransmission"] : '-' }}
                        </span>
                        } @else {
                            <input type="text" class="matching-item-text"
                                   formControlName="engineTransmission"
                                   (click)="stopPropagation($event)"/>
                        }
                      </span>

                    <span class="matching-detail-item">
                    <span class="matching-item-name">Engine Producer</span>
                        @if (!editFlags["engineProducer"]) {
                            <span class="matching-item-text cursor"
                                  (click)="toggleEdit('engineProducer', $event)">
                            {{ masterDetailsFormGroup.get('engineProducer').value ? masterDetailObject()["engineProducer"] : '-' }}
                        </span>
                        } @else {
                            <input type="text" class="matching-item-text"
                                   formControlName="engineProducer"
                                   (click)="stopPropagation($event)"/>
                        }
                      </span>

                    <span class="matching-detail-item">
                    <span class="matching-item-name">Engine Displacement</span>
                        @if (!editFlags["engineDisplacement"]) {
                            <span class="matching-item-text cursor"
                                  (click)="toggleEdit('engineDisplacement', $event)">
                            {{ masterDetailsFormGroup.get('engineDisplacement').value ? masterDetailObject()["engineDisplacement"] : '-' }}
                        </span>
                        } @else {
                            <input type="text" class="matching-item-text"
                                   formControlName="engineDisplacement"
                                   (click)="stopPropagation($event)"/>
                        }
                      </span>

                    <span class="matching-detail-item">
                    <span class="matching-item-name">Vehicle Build</span>
                        @if (!editFlags["vehicleBuild"]) {
                            <span class="matching-item-text cursor"
                                  (click)="toggleEdit('vehicleBuild', $event)">
                            {{ masterDetailsFormGroup.get('vehicleBuild').value ? masterDetailObject()["vehicleBuild"] : '-' }}
                        </span>
                        } @else {
                            <input type="text" class="matching-item-text"
                                   formControlName="vehicleBuild"
                                   (click)="stopPropagation($event)"/>
                        }
                      </span>


                    <span class="matching-detail-item">
                    <span class="matching-item-name">Vehicle Model Year</span>
                        @if (!editFlags["vehicleModelYear"]) {
                            <span class="matching-item-text cursor"
                                  (click)="toggleEdit('vehicleModelYear', $event)">
                            {{ masterDetailsFormGroup.get('vehicleModelYear').value ? masterDetailObject()["vehicleModelYear"] : '-' }}
                        </span>
                        } @else {
                            <input type="text" class="matching-item-text"
                                   formControlName="vehicleModelYear"
                                   (click)="stopPropagation($event)"/>
                        }
                      </span>
                </div>
                <div class="info-column">

                    <span class="matching-detail-item">
                    <span class="matching-item-name">Ecu Use</span>
                        @if (!editFlags["ecuUse"]) {
                            <span class="matching-item-text cursor"
                                  (click)="toggleEdit('ecuUse', $event)">
                            {{ masterDetailsFormGroup.get('ecuUse').value ? masterDetailObject()["ecuUse"] : '-' }}
                        </span>
                        } @else {
                            <input type="text" class="matching-item-text"
                                   formControlName="ecuUse"
                                   (click)="stopPropagation($event)"/>
                        }
                      </span>

                    <span class="matching-detail-item">
                    <span class="matching-item-name">Hp</span>
                        @if (!editFlags["outputPs"]) {
                            <span class="matching-item-text cursor"
                                  (click)="toggleEdit('outputPs', $event)">
                            {{ masterDetailsFormGroup.get('outputPs').value ? masterDetailObject()["outputPs"] : '-' }}
                        </span>
                        } @else {
                            <input type="text" class="matching-item-text"
                                   formControlName="outputPs"
                                   (click)="stopPropagation($event)"/>
                        }
                      </span>

                    <span class="matching-detail-item">
                    <span class="matching-item-name">Kw</span>
                        @if (!editFlags["outputKw"]) {
                            <span class="matching-item-text cursor"
                                  (click)="toggleEdit('outputKw', $event)">
                            {{ masterDetailsFormGroup.get('outputKw').value ? masterDetailObject()["outputKw"] : '-' }}
                        </span>
                        } @else {
                            <input type="text" class="matching-item-text"
                                   formControlName="outputKw"
                                   (click)="stopPropagation($event)"/>
                        }
                      </span>


                    <span class="matching-detail-item">
                    <span class="matching-item-name">Nm</span>
                        @if (!editFlags["engineMaxTorque"]) {
                            <span class="matching-item-text cursor"
                                  (click)="toggleEdit('engineMaxTorque', $event)">
                            {{ masterDetailsFormGroup.get('engineMaxTorque').value ? masterDetailObject()["engineMaxTorque"] : '-' }}
                        </span>
                        } @else {
                            <input type="text" class="matching-item-text"
                                   formControlName="engineMaxTorque"
                                   (click)="stopPropagation($event)"/>
                        }
                      </span>

                    <span class="matching-detail-item">
                    <span class="matching-item-name">Vehicle Type</span>
                        @if (!editFlags["vehicleType"]) {
                            <span class="matching-item-text cursor"
                                  (click)="toggleEdit('vehicleType', $event)">
                            {{ masterDetailsFormGroup.get('vehicleType').value ? masterDetailObject()["vehicleType"] : '-' }}
                        </span>
                        } @else {
                            <input type="text" class="matching-item-text"
                                   formControlName="vehicleType"
                                   (click)="stopPropagation($event)"/>
                        }
                      </span>

                    <span class="matching-detail-item">
                    <span class="matching-item-name">Vehicle Characteristic </span>
                        @if (!editFlags["vehicleCharacteristic"]) {
                            <span class="matching-item-text cursor"
                                  (click)="toggleEdit('vehicleCharacteristic', $event)">
                            {{ masterDetailsFormGroup.get('vehicleCharacteristic').value ? masterDetailObject()["vehicleCharacteristic"] : '-' }}
                        </span>
                        } @else {
                            <input type="text" class="matching-item-text"
                                   formControlName="vehicleCharacteristic"
                                   (click)="stopPropagation($event)"/>
                        }
                      </span>
                </div>


            </div>
            @if (isVisibleButton()) {
                <div class="save-button">
                    <button type="button" class="add-tuning-button"
                            (click)="submitForm()" [disabled]="!masterDetailsFormGroup.valid">Save
                    </button>
                    <button type="button" class="add-tuning-button"
                            (click)="cancelForm()">Cancel
                    </button>
                </div>

            }

        </form>

        <div class="button-wrapper">
            <button type="button" class="add-tuning-button" (click)="toggleShowMore()">
                {{ showMore ? 'See less details...' : 'See more details... ' }}
            </button>
        </div>


        <div class="file-upload-container">
            <app-upload-file (file)="uploadIniFile($event)" [error]="allMastersService.myInputs.get('ini').message"
                             [inputText]="allMastersService.inputText" customBackground="var(--primary-nav-bg)"
                             [progressWidth]="allMastersService.progressWidth()"
                             [resetSignal]="allMastersService.resetSignal()"></app-upload-file>
        </div>

    }
</div>
